import { CameraOpts } from '../rtsp-h264-mjpeg/rtsp-h264-mjpeg-interface';

export interface SipOpts {
  server: string;
  aor?: string;
  authorizationPassword?: string;
  authorizationUsername?: string;
  viaHost?: string;
  target: string;
};

export interface Button {
  name: string;
}

export interface DataIn {
  name: string;
  camera?: CameraOpts;
  ring?: boolean;
  sip?: SipOpts;
  buttons?: Button[];
};
